const metaKeywords = {
  ru: {
    homePage:
      "перелеты, авиабилеты, дешевые авиабилеты, купить авиабилеты онлайн, авиабилеты Узбекистан, авиабилеты Ташкент, бронирование авиабилетов, поиск авиабилетов, сравнение цен на билеты, международные рейсы, внутренние рейсы, туризм, путешествия, визовая поддержка, визовые услуги, оформление визы, Aviamarket, билеты на самолет, дешевые перелеты, акции на авиабилеты, горящие туры",
    aeroflotInfo:
      "Аэрофлот, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Аэрофлот",
    uzairways:
      "aviabilet, авиабилет, Uzbekistan Airways, авиабилеты Ташкент, рейсы Узбекистан, купить билет на самолет, авиаперелеты",
    turkishInfo:
      "aviabilet, авиабилет, Turkish Airlines, авиабилеты Ташкент, рейсы Turkish Airlines, авиабилеты Стамбул, купить авиабилет дешево",
    belaviaInfo:
      "Belavia, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    uralAirlinesInfo:
      "aviabilet, авиабилет, Ural Airlines, авиабилеты Ташкент, рейсы Ural Airlines, авиабилеты Москва, купить авиабилет дешево",
    s7Info:
      "viabilet, авиабилет, S7 Airlines, авиабилеты Ташкент, рейсы S7, авиабилеты Москва, купить авиабилет дешево",
    qanotsharqInfo:
      "qanot sharq, авиабилеты, авиабилеты ташкент, дешёвые авиабилеты, билеты узбекистан, билеты москва ташкент, qanot sharq расписание",
    pobedaInfo:
      "pobeda, авиабилеты, авиабилеты ташкент, дешёвые авиабилеты, билеты узбекистан, билеты москва ташкент, pobeda расписание",
    airastanaInfo:
      "Air Astana, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    flyaristanInfo:
      "FlyArystan, авиакомпания Казахстан, лоукост, рейсы Ташкент–Алматы, дешёвые билеты, авиаперелёты в Центральной Азии, Airbus A320",
    aircairoInfo:
      "Air Cairo, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    airchinaInfo:
      "Air China, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    airmanasInfo:
      "Air Manas, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    asianaAirlinesInfo:
      "Asiana Airlines, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    aviaTrafficInfo:
      "Avia Traffic Company, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    azalInfo:
      "AZAL, Azerbaijan Airlines, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    azimuthInfo:
      "Azimuth, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    azurairInfo:
      "Azur Air, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet sankt peterburg",
    spicejetInfo:
      "aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet hindiston, aviabilet delhi, spicejet uzbekistan, spicejet aviabilet, arzon aviabilet, авиабилеты Индия, авиабилеты Ташкент Дели",
    irAeroInfo: "iraero, авиабилеты узбекистан россия, чартер ташкент иркутск, irkutsk flights, авиарейсы в сибирь",
    auroraAirlinesInfo: "Aurora Airlines, Аврора, региональные рейсы, Дальний Восток, Сибирь, авиакомпания Россия",
    yamalAirlinesInfo: "Yamal Airlines, авиабилеты, Ямало-Ненецкий округ, Airbus A320, Sukhoi Superjet 100",
    yakutiaAirlinesInfo: "Якутия Airlines, авиакомпания Якутия, флот, Boeing 737, Sukhoi Superjet 100",
    rossiyaAirlinesInfo:
      "Rossiya Airlines, aviabilet, aviabilet narxlari, авиабилеты дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Rossiya Airlines",
    nordwindAirInfo:
      "Nordwind Airlines, чартерные авиарейсы, рейсы Ташкент-Анталия, Ташкент-Бодрум, авиапарк, Airbus A321, Boeing 737-800, купить авиабилет, чартеры Узбекистан",
    lufthansaAirInfo:
      "Lufthansa, авиабилеты, Франкфурт, Ташкент–Германия, рейсы Lufthansa, купить билет Lufthansa, Airbus A350, Boeing 747-8",
    silkAirInfo:
      "SilkAir, Singapore Airlines, рейсы Сингапур, авиакомпания SilkAir, Boeing 737, пересадки через Сингапур, история SilkAir",
    tajikAirInfo:
      "Tajik Air, Таджикистан, рейсы Душанбе, авиарейсы в Узбекистан, авиакомпания Таджикистана, Boeing 737, старейшая авиакомпания, таджикская авиация",
    somonAirInfo:
      "Somon Air, рейсы Душанбе, авиабилеты Таджикистан, чартеры, Boeing 737-800, Tashkent–Dushanbe, авиакомпания Таджикистана",
    kamairInfo:
      "Kam Air, авиакомпания Афганистана, рейсы Кабул, авиабилеты, чартеры, Airbus A340, Boeing 737, Ташкент–Кабул",
    ilkarAirInfo:
      "Ilkar Air, чартерные рейсы, Ташкент–Анталия, Ташкент–Баку, Embraer E190, Boeing 737, авиакомпания Турция",
    flydubaiAirInfo:
      "flydubai, авиабилеты в Дубай, рейсы Ташкент–Дубай, Emirates, Boeing 737 MAX, бюджетные авиаперелёты, авиакомпания ОАЭ",
    kuwaitAirwaysInfo:
      "Kuwait Airways, рейсы Кувейт, Ташкент–Кувейт, авиабилеты, Airbus A330neo, Boeing 777, авиакомпания Персидского залива",
    emiratesAirInfo:
      "Emirates, авиабилеты, рейсы Ташкент–Дубай, Airbus A380, Boeing 777, премиум авиакомпания, ОАЭ, международные перелёты",
    centrumAirInfo:
      "Centrum Air, Узбекистан, дешевые авиабилеты, Ташкент, Airbus A320, внутриреспубликанские рейсы, авиакомпания Узбекистана, лоукостер",
    egyptAirInfo:
      "EgyptAir, рейсы Ташкент–Каир, авиакомпания Египта, Star Alliance, Airbus A320, Boeing 787, авиабилеты в Египет",
    chinaSouthernInfo:
      "China Southern Airlines, рейсы Ташкент–Гуанчжоу, авиакомпания Китая, Airbus A350, Boeing 777, китайские авиалинии, авиабилеты",
    piaInfo:
      "PIA, Pakistan International Airlines, авиабилеты Ташкент–Исламабад, Boeing 777, Airbus A320, чартерные рейсы Пакистан, авиакомпания Пакистана",
    airblueInfo:
      "Airblue, авиакомпания Пакистан, рейсы Ташкент–Исламабад, Airbus A320, Airbus A321, авиабилеты Пакистан, частный перевозчик",
    sereneAirInfo:
      "SereneAir, авиакомпания Пакистана, Boeing 737, Airbus A330, рейсы Ташкент–Исламабад, чартеры, частный перевозчик",
    airIndiaInfo:
      "Air India, авиакомпания Индии, рейсы Ташкент–Дели, Boeing 787, Airbus A320, Tata Group, прямые рейсы в Индию",
    vistaraInfo:
      "Vistara, авиакомпания Индии, рейсы через Дели, Airbus A320neo, Boeing 787 Dreamliner, Tata Group, Singapore Airlines, авиабилеты Индия",
    gulfAirInfo:
      "Gulf Air, авиакомпания Бахрейн, Boeing 787, Airbus A320neo, рейсы Ташкент–Манама, ближневосточный перевозчик, стыковки",
    omanAirInfo:
      "Oman Air, авиакомпания Оман, Ташкент–Маскат, Boeing 737, Boeing 787, авиабилеты в Оман, ближневосточные авиалинии",
    salamAirInfo:
      "SalamAir, авиакомпания Оман, Ташкент–Маскат, Самарканд–Маскат, лоукост авиабилеты, Airbus A320, бюджетные рейсы, чартеры Узбекистан",
    iranAsemanAirlinesInfo:
      "Iran Aseman Airlines, иранские авиалинии, рейсы в Иран, Тегеран–Ташкент, региональные самолёты, чартеры Узбекистан, авиакомпания Ирана",
    kishAirInfo:
      "Kish Air, авиакомпания Иран, остров Киш, внутренние рейсы, MD-82, Fokker 100, Airbus A321, Тегеран–Киш, чартеры",
    qeshmAirInfo:
      "Qeshm Air, авиакомпания Иран, Тегеран–Кешм, внутренние рейсы, Airbus A300, Fokker 100, чартерные рейсы, региональный перевозчик",
    syrianAirInfo:
      "SyrianAir, авиакомпания Сирия, рейсы Дамаск, Airbus A320, ближневосточные авиалинии, национальный перевозчик Сирии, авиабилеты",
    middleEastAirlinesInfo:
      "Middle East Airlines, MEA, авиакомпания Ливан, рейсы Бейрут, Airbus A320neo, A330, авиабилеты SkyTeam, рейсы из Ташкента",
    aircompanyArmeniaInfo:
      "Aircompany Armenia, армянская авиакомпания, рейсы в Ереван, Boeing 737-500, авиабилеты Армения, перелёты из Узбекистана",
    arianaAfghanAirlinesInfo:
      "Ariana Afghan Airlines, авиакомпания Афганистан, Кабул, рейсы в Азию, Boeing 737-400, Airbus A310, авиабилеты, афганские авиалинии",
    georgianAirwaysInfo:
      "Georgian Airways, авиакомпания Грузия, рейсы Тбилиси, Ташкент–Тбилиси, Embraer 190, Boeing 737, авиабилеты в Грузию",
    myWayAirlinesInfo:
      "MyWay Airlines, грузинская авиакомпания, рейсы Тбилиси, Ташкент, Самарканд, Boeing 737-800, чартеры, СНГ, авиабилеты",
    koreanAirInfo:
      "Korean Air, Сеул авиабилеты, рейсы в Корею, Ташкент–Сеул, Airbus A380, Boeing 777, SkyTeam, премиум авиакомпания, Корея",
    jazeeraAirwaysInfo:
      "Jazeera Airways, авиакомпания Кувейт, рейсы Ташкент–Кувейт, бюджетные авиабилеты, A320neo, авиарейсы Персидский залив, Jazeera Uzbekistan",
    mahanAirInfo:
      "Mahan Air, авиакомпания Иран, рейсы в Тегеран, Airbus A310, A300, A340, BAe 146, международные рейсы, авиабилеты Ташкент",
    indigoAirlinesInfo:
      "IndiGo Airlines, авиакомпания Индия, рейсы Ташкент–Дели, A320neo, бюджетные авиабилеты, индийские маршруты, авиаперевозчик Индии",
    alrosaAirlinesInfo:
      "Alrosa Airlines, авиакомпания Якутия, рейсы Сибирь, Ту-154, Ан-24, Boeing 737, чартерные рейсы, авиаперевозки Якутск",
    turkmenistanAirlinesInfo:
      "Turkmenistan Airlines, авиакомпания Туркменистан, рейсы Ташкент–Ашхабад, Boeing 737, Boeing 777, центральноазиатские авиалинии",
    saudiaAirlinesInfo:
      "Saudia Airlines, Saudi Arabian Airlines, Ташкент–Джидда, хадж, умра, авиабилеты в Саудовскую Аравию, рейсы Джидда, Эр-Рияд, Airbus A330, Boeing 777",
    pegasusAirInfo:
      "Pegasus Airlines, aviabilet, aviabilet narxlari, бюджетные авиабилеты, Uzbekistan–Istanbul, Sabiha Gökçen, Airbus A320-200, Airbus A320neo, Airbus A321neo, Boeing 737-800, купить авиабилеты, лоукостер Турция",
    wizzAirInfo:
      "Wizz Air, авиабилеты Wizz Air, купить билет Wizz Air, дешевые авиабилеты, расписание Wizz Air, рейсы из Ташкента, рейсы из Самарканда",
    qatarAirwaysInfo:
      "Qatar Airways, авиабилеты Qatar Airways, купить билет Qatar Airways, рейсы из Ташкента, рейсы в Доху, дешевые авиабилеты, расписание Qatar Airways",
    airBalticInfo:
      "airBaltic, авиабилеты airBaltic, купить билет airBaltic, рейсы из Ташкента, рейсы в Ригу, дешевые авиабилеты, расписание airBaltic",
    tashkent_istanbulInfo: "Ташкент Стамбул, авиабилеты, прямой рейс, расписание, Aviamarket",
    tashkent_moscowInfo: "Ташкент Москва, авиабилеты, прямой рейс, расписание, Aviamarket",
    tashkent_dubaiInfo: "Ташкент Дубай, авиабилеты, рейсы, прямой рейс, расписание, Aviamarket",
    tashkent_dushanbeInfo:
      "авиабилеты Ташкент Душанбе, дешевые билеты Душанбе, Uzbekistan Airways Душанбе, Somon Air Душанбе",
    tashkent_beijingInfo: "авиабилеты Ташкент Пекин, прямой рейс Ташкент Пекин, купить билет Ташкент Пекин",
    tashkent_bishkekInfo: "авиабилеты Ташкент Бишкек, прямой рейс Ташкент Бишкек, купить билет Ташкент Бишкек",
    tashkent_belarusInfo:
      "авиабилеты Ташкент Беларусь, прямой рейс Ташкент Минск, купить билет Ташкент Минск, дешевые билеты в Беларусь, перелет Ташкент Минск",
    tashkent_almatyInfo: "авиабилеты Ташкент Алматы, прямой рейс Ташкент Алматы, купить билет Ташкент Алматы",
    tashkent_azerbaijanInfo:
      "авиабилеты Ташкент Баку, рейсы в Баку, Uzbekistan Airways Баку, AZAL рейсы, дешевые авиабилеты",
    tashkent_georgiaInfo: "авиабилеты Ташкент Грузия, прямой рейс Ташкент Грузия, купить билет Ташкент Грузия",
    tashkent_saudiInfo: "авиабилеты Ташкент Саудия, прямой рейс Ташкент Саудия, купить билет Ташкент Саудия",
    tashkent_qatarInfo: "авиабилеты Ташкент Катар, прямой рейс Ташкент Катар, купить билет Ташкент Катар",
    tashkent_polandInfo: "авиабилеты Ташкент Польша, прямой рейс Ташкент Польша, купить билет Ташкент Польша",
    tashkent_latviaInfo: "авиабилеты Ташкент Рига, прямой рейс Ташкент Рига, купить билет Ташкент Рига",
    tashkent_franceInfo: "авиабилеты Ташкент Франция, прямой рейс Ташкент Франция, купить билет Ташкент Франция",
    tashkent_italyInfo: "авиабилеты Ташкент Рим, прямой рейс Ташкент Рим, купить билет Ташкент Рим",
    tashkent_spainInfo: "авиабилеты Ташкент Испания, прямой рейс Ташкент Испания, купить билет Ташкент Испания",
    tashkent_ukInfo:
      "авиабилеты Ташкент Великобритания, прямой рейс Ташкент Великобритания, купить билет Ташкент Великобритания",
    tashkent_germanyInfo: "авиабилеты Ташкент Германия, прямой рейс Ташкент Германия, купить билет Ташкент Германия",
    tashkent_czechiaInfo: "авиабилеты Ташкент Чехия, прямой рейс Ташкент Чехия, купить билет Ташкент Чехия",
    tashkent_seoulInfo: "авиабилеты Ташкент Сеул, прямой рейс Ташкент Сеул, купить билет Ташкент Сеул",
    tashkent_pusanInfo: "авиабилеты Ташкент Пусан, прямой рейс Ташкент Пусан, купить билет Ташкент Пусан",
    tashkent_tokyoInfo: "авиабилеты Ташкент Токио, прямой рейс Ташкент Токио, купить билет Ташкент Токио",
    tashkent_bangkokInfo: "авиабилеты Ташкент Бангкок, прямой рейс Ташкент Бангкок, купить билет Ташкент Бангкок",
    tashkent_phuketInfo: "авиабилеты Ташкент Пхукет, прямой рейс Ташкент Пхукет, купить билет Ташкент Пхукет",
    tashkent_kualalumpurInfo:
      "авиабилеты Ташкент Куала-Лумпур, прямой рейс Ташкент Куала-Лумпур, купить билет Ташкент Куала-Лумпур",
    tashkent_islamabadInfo:
      "авиабилеты Ташкент Исламабад, прямой рейс Ташкент Исламабад, купить билет Ташкент Исламабад",
    tashkent_danangInfo: "авиабилеты Ташкент Дананг, рейсы во Вьетнам, дешевые билеты Ташкент Дананг",
    tashkent_delhiInfo: "авиабилеты Ташкент Дели, прямой рейс Ташкент Дели, Индия Ташкент рейс",
    tashkent_denpasarInfo: "авиабилеты Ташкент Бали, перелёт Ташкент Денпасар, отдых на Бали из Ташкента",
    tashkent_lahoreInfo: "авиабилеты Ташкент Лахор, прямой рейс Ташкент Лахор, Пакистан из Ташкента",
    tashkent_mopaInfo: "авиабилеты Ташкент Гоа, рейс Ташкент Мопа, отдых в Гоа из Ташкента",
    tashkent_mumbaiInfo: "авиабилеты Ташкент Мумбай, рейс Ташкент Индия, прямой перелет в Мумбай",
    tashkent_krasnoyarskInfo:
      "авиабилеты Ташкент Красноярск, прямой рейс Ташкент Красноярск, купить билет Ташкент Красноярск",
    tashkent_novgorodInfo: "авиабилеты Ташкент Новгород, прямой рейс Ташкент Новгород, купить билет Ташкент Новгород",
    tashkent_kuwaitcityInfo:
      "авиабилеты Ташкент Кувейт-Сити, прямой рейс Ташкент Кувейт-Сити, купить билет Ташкент Кувейт-Сити",
    tashkent_tbilisiInfo: "Ташкент Тбилиси рейс, arzon chipta Tbilisi",
    tashkent_batumiInfo: "Ташкент Батуми рейс, arzon chipta Batumi",
    tashkent_warsawInfo: "Ташкент Варшава рейс, arzon chipta Varshava",
    tashkent_rigaInfo: "Ташкент Рига рейс, arzon chipta Riga",
    tashkent_sharmelsheikhInfo: "Ташкент Шарм Эль Шеikh рейс, arzon chipta Sharm El Sheikh",
    tashkent_jeddahInfo: "Ташкент Джедда рейс, arzon chipta Jeddah",
    tashkent_medinaInfo: "Ташкент медина дешевые рейсы, arzon chipta Medina",
    tashkent_oshInfo:
      "Тошкентдан Ошга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_issyk_kulInfo:
      "Тошкентдан Иссик-Кўлга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_ashgabatInfo:
      "Тошкентдан Ашхободга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_sharjahInfo:
      "Тошкентдан Шаржага арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_sanyaInfo:
      "Тошкентдан Саньяга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_hangzhouInfo:
      "Тошкентдан Ханчжоуга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_xianInfo:
      "Тошкентдан Сианга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_chengduInfo:
      "Тошкентдан Чендуга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_urumqiInfo:
      "Тошкентдан Урумчига арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    tashkent_busanInfo:
      "Тошкентдан Пусанга арзон ва қулай авиарейслар. Онлайн бронь, тезкор парвозлар ва энг яхши нархларда чипталар — Aviamarket.me сайтида.",
    flightsList: "направления рейсов, все рейсы, авиабилеты направления, маршруты самолётов, купить авиабилеты, дешёвые рейсы",
    airlines: "авиакомпании, список авиакомпаний, обзор авиакомпаний, рейсы авиакомпаний, маршруты авиакомпаний",
    aboutPage: "о компании dushanbe24, онлайн касса таджикистан, купить авиабилеты душанбе, dushanbe24 история",
    contactsPage: "контакты dushanbe24, связаться с нами, поддержка авиабилеты, помощь покупка билетов",
    servicesPage: "услуги dushanbe24, поиск авиабилетов, бронирование рейсов, визовая поддержка, онлайн покупка билетов",
    partnersPage: "партнёры dushanbe24, авиакомпании партнёры, агенты авиабилеты, поставщики рейсов",
    paymentInfoPage: "оплата авиабилетов, способы оплаты, банковские карты, онлайн оплата билетов",
    privacyPolicyPage: "политика конфиденциальности, защита данных, персональные данные dushanbe24",
    publicOfferPage: "публичная оферта, условия продажи авиабилетов, договор dushanbe24",
    rulesOfUsePage: "правила пользования, условия использования, правила сервиса dushanbe24",
  },
  tj: {
    homePage:
      "парвозҳо, чиптаҳои ҳавопаймо, чиптаҳои арзон, хариди чипта онлайн, чиптаҳои Ӯзбекистон, чиптаҳои Тошканд, брон кардани чиптаҳои ҳавопаймо, ҷустуҷӯи чиптаҳо, муқоисаи нархҳо, рейсҳои байналмилалӣ, рейсҳои дохилӣ, туризм, сафар, дастгирии раводид, хадамоти раводид, раводид, Aviamarket, чиптаҳои ҳавопаймо, парвозҳои арзон, аксияҳои чиптаҳо, турҳои фурӯзон",

    aeroflotInfo:
      "Аэрофлот, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet maskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, хариди чиптаҳои ҳавопаймо, чиптаҳои Аэрофлот",

    uzairways:
      "aviabilet, чиптаҳои ҳавопаймо, Uzbekistan Airways, чиптаҳои Тошканд, рейсҳои Ӯзбекистон, хариди чипта, парвозҳо",

    turkishInfo:
      "aviabilet, чиптаҳои ҳавопаймо, Turkish Airlines, чиптаҳои Тошканд, рейсҳои Turkish Airlines, чиптаҳои Истамбул, хариди чипта арзон",

    belaviaInfo: "Belavia, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    uralAirlinesInfo:
      "aviabilet, чиптаҳои ҳавопаймо, Ural Airlines, чиптаҳои Тошканд, рейсҳои Ural Airlines, чиптаҳои Москва, хариди чипта арзон",

    s7Info:
      "aviabilet, чиптаҳои ҳавопаймо, S7 Airlines, чиптаҳои Тошканд, рейсҳои S7, чиптаҳои Москва, хариди чипта арзон",

    qanotsharqInfo:
      "qanot sharq, чиптаҳои ҳавопаймо, чиптаҳои Тошканд, чиптаҳои арзон, чиптаҳои Ӯзбекистон, чиптаҳои москва–ташкент, ҷадвали qanot sharq",

    pobedaInfo:
      "pobeda, чиптаҳои ҳавопаймо, чиптаҳои Тошканд, чиптаҳои арзон, чиптаҳои Ӯзбекистон, чиптаҳои москва–ташкент, ҷадвали pobeda",

    airastanaInfo:
      "Air Astana, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    flyaristanInfo:
      "FlyArystan, ширкати ҳавопаймоии Қазоқистон, лоукост, рейсҳои Тошканд–Алматы, чиптаҳои арзон, парвозҳои Осиёи Марказӣ, Airbus A320",

    aircairoInfo:
      "Air Cairo, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    airchinaInfo:
      "Air China, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    airmanasInfo:
      "Air Manas, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    asianaAirlinesInfo:
      "Asiana Airlines, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    aviaTrafficInfo:
      "Avia Traffic Company, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    azalInfo:
      "AZAL, Azerbaijan Airlines, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    azimuthInfo: "Azimuth, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    azurairInfo:
      "Azur Air, aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet moskva, aviabilet sankt peterburg",

    spicejetInfo:
      "aviabilet, aviabilet narxlari, aviabilet арзон, aviabilet hindiston, aviabilet delhi, spicejet uzbekistan, spicejet aviabilet, arzon aviabilet, чиптаҳои Ҳиндустон, чиптаҳои Тошканд–Деҳлӣ",

    irAeroInfo: "iraero, чиптаҳои Ӯзбекистон–Руссия, чартер Тошканд–Иркутск, рейсҳои Иркутск, парвозҳо ба Сибир",

    auroraAirlinesInfo: "Aurora Airlines, Аврора, рейсҳои минтақавӣ, Дури Шарқ, Сибир, ширкати ҳавопаймоии Русия",

    yamalAirlinesInfo: "Yamal Airlines, чиптаҳои ҳавопаймо, Ямало-Ненецкий округ, Airbus A320, Sukhoi Superjet 100",

    yakutiaAirlinesInfo: "Якутия Airlines, ширкати ҳавопаймоии Якутия, флот, Boeing 737, Sukhoi Superjet 100",

    rossiyaAirlinesInfo:
      "Rossiya Airlines, aviabilet, aviabilet narxlari, чиптаҳои арзон, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, хариди чипта, чиптаҳои Rossiya Airlines",

    nordwindAirInfo:
      "Nordwind Airlines, чартерҳо, рейсҳои Тошканд–Анталия, Тошканд–Бодрум, Airbus A321, Boeing 737-800, хариди чипта, чартерҳои Ӯзбекистон",

    lufthansaAirInfo:
      "Lufthansa, чиптаҳои ҳавопаймо, Франкфурт, Тошканд–Олмон, рейсҳои Lufthansa, хариди чипта, Airbus A350, Boeing 747-8",

    silkAirInfo:
      "SilkAir, Singapore Airlines, рейсҳои Сингапур, ширкати SilkAir, Boeing 737, стыковкаҳо тавассути Сингапур, таърих",

    tajikAirInfo:
      "Tajik Air, Тоҷикистон, рейсҳои Душанбе, парвозҳо ба Ӯзбекистон, ширкати ҳавопаймоии Тоҷикистон, Boeing 737, куҳантарин ширкат",

    somonAirInfo: "Somon Air, рейсҳои Душанбе, чиптаҳои Тоҷикистон, чартерҳо, Boeing 737-800, Tashkent–Dushanbe",

    kamairInfo: "Kam Air, ширкати Афғонистон, рейсҳои Кобул, чиптаҳо, чартерҳо, Airbus A340, Boeing 737, Тошканд–Кобул",

    ilkarAirInfo: "Ilkar Air, чартерҳо, Тошканд–Анталия, Тошканд–Боку, Embraer E190, Boeing 737, ширкати Туркия",

    flydubaiAirInfo:
      "flydubai, чиптаҳо ба Дубай, Тошканд–Дубай, Emirates, Boeing 737 MAX, парвозҳои буҷавӣ, ширкати АМА",

    kuwaitAirwaysInfo: "Kuwait Airways, рейсҳои Кувайт, Тошканд–Кувайт, чиптаҳо, Airbus A330neo, Boeing 777",

    emiratesAirInfo: "Emirates, чиптаҳо, рейсҳои Тошканд–Дубай, Airbus A380, Boeing 777, ширкати премиум, АМА",

    centrumAirInfo: "Centrum Air, Ӯзбекистон, чиптаҳои арзон, Тошканд, Airbus A320, рейсҳои дохилӣ, ширкати лоукост",

    egyptAirInfo: "EgyptAir, рейсҳои Тошканд–Қоҳира, ширкати Миср, Star Alliance, Airbus A320, Boeing 787",

    chinaSouthernInfo: "China Southern Airlines, рейсҳои Тошканд–Гуанчжоу, ширкати Чин, Airbus A350, Boeing 777",

    piaInfo: "PIA, Pakistan International Airlines, чиптаҳои Тошканд–Исламабад, Boeing 777, Airbus A320",

    airblueInfo: "Airblue, ширкати хусусии Покистон, рейсҳои Тошканд–Исламабад, Airbus A320, Airbus A321",

    sereneAirInfo: "SereneAir, ширкати Покистон, Boeing 737, Airbus A330, рейсҳои Тошканд–Исламабад",

    airIndiaInfo: "Air India, ширкати Ҳиндустон, рейсҳои Тошканд–Дели, Boeing 787, Airbus A320",

    vistaraInfo: "Vistara, ширкати Ҳиндустон, рейсҳо тавассути Деҳлӣ, Airbus A320neo, Boeing 787 Dreamliner",

    gulfAirInfo: "Gulf Air, ширкати Баҳрайн, Boeing 787, Airbus A320neo, рейсҳои Тошканд–Манама",

    omanAirInfo: "Oman Air, ширкати Умон, Тошканд–Маскат, Boeing 737, Boeing 787",

    salamAirInfo: "SalamAir, ширкати Умон, Тошканд–Маскат, Самарқанд–Маскат, Airbus A320, чартерҳо",

    iranAsemanAirlinesInfo: "Iran Aseman Airlines, ширкати Эрон, рейсҳо ба Эрон, Теҳрон–Тошканд",

    kishAirInfo: "Kish Air, ширкати Эрон, ҷазираи Киш, рейсҳои дохилӣ, MD-82, Fokker 100",

    qeshmAirInfo: "Qeshm Air, ширкати Эрон, Теҳрон–Кешм, рейсҳои дохилӣ, Airbus A300, Fokker 100",

    syrianAirInfo: "SyrianAir, ширкати Сурия, рейсҳои Димишқ, Airbus A320",

    middleEastAirlinesInfo: "Middle East Airlines, MEA, ширкати Лубнон, рейсҳои Бейрут, Airbus A320neo, A330",

    aircompanyArmeniaInfo: "Aircompany Armenia, ширкати Арманистон, рейсҳо ба Ереван, Boeing 737-500",

    arianaAfghanAirlinesInfo: "Ariana Afghan Airlines, ширкати Афғонистон, Кобул, Airbus A310, Boeing 737",

    georgianAirwaysInfo: "Georgian Airways, ширкати Гурҷистон, Тошканд–Тбилиси, Embraer 190, Boeing 737",

    myWayAirlinesInfo: "MyWay Airlines, ширкати Гурҷистон, Тбилиси, Тошканд, Самарқанд, Boeing 737-800",

    koreanAirInfo: "Korean Air, чиптаҳои Сеул, рейсҳои Тошканд–Сеул, Airbus A380, Boeing 777",

    jazeeraAirwaysInfo: "Jazeera Airways, ширкати Кувайт, Тошканд–Кувайт, чиптаҳои арзон, A320neo",

    mahanAirInfo: "Mahan Air, ширкати Эрон, рейсҳои Теҳрон, Airbus A310, A300, A340",

    indigoAirlinesInfo: "IndiGo Airlines, ширкати Ҳиндустон, рейсҳои Тошканд–Дели, A320neo",

    alrosaAirlinesInfo: "Alrosa Airlines, ширкати Якутия, рейсҳои Сибир, Ту-154, Boeing 737",

    turkmenistanAirlinesInfo: "Turkmenistan Airlines, Тошканд–Ашхабад, Boeing 737, Boeing 777",

    saudiaAirlinesInfo: "Saudia Airlines, рейсҳои Тошканд–Ҷидда, ҳаҷ, умра, Airbus A330, Boeing 777",

    pegasusAirInfo:
      "Pegasus Airlines, aviabilet, aviabilet narxlari, чиптаҳои арзон, Uzbekistan–Istanbul, Sabiha Gökçen, Airbus A320, Boeing 737-800",

    wizzAirInfo: "Wizz Air, чиптаҳои арзон Wizz Air, хариди чипта, ҷадвали Wizz Air, рейсҳои Тошканд, Самарқанд",

    qatarAirwaysInfo: "Qatar Airways, чиптаҳои арзон, хариди чипта, рейсҳои Тошканд, рейсҳои Доха",

    airBalticInfo: "airBaltic, чиптаҳои арзон, рейсҳои Тошканд, рейсҳои Рига, ҷадвали airBaltic",

    tashkent_istanbulInfo: "Тошканд–Истамбул, чиптаҳо, рейси мустақим, ҷадвал, Aviamarket",

    tashkent_moscowInfo: "Тошканд–Москва, чиптаҳо, рейси мустақим, ҷадвал, Aviamarket",

    tashkent_dubaiInfo: "Тошканд–Дубай, чиптаҳо, рейсҳои мустақим, ҷадвал, Aviamarket",

    tashkent_dushanbeInfo: "чиптаҳои Тошканд–Душанбе, чиптаҳои арзон, Uzbekistan Airways Душанбе, Somon Air Душанбе",

    tashkent_beijingInfo: "чиптаҳои Тошканд–Пекин, рейси мустақим, хариди чипта",

    tashkent_bishkekInfo: "чиптаҳои Тошканд–Бишкек, рейси мустақим, хариди чипта",

    tashkent_belarusInfo: "чиптаҳои Тошканд–Беларус, рейси мустақим Тошканд–Минск, чиптаҳои арзон",

    tashkent_almatyInfo: "чиптаҳои Тошканд–Алматы, рейси мустақим, хариди чипта",

    tashkent_azerbaijanInfo: "чиптаҳои Тошканд–Боку, рейсҳо ба Боку, Uzbekistan Airways, AZAL, чиптаҳои арзон",

    tashkent_georgiaInfo: "чиптаҳои Тошканд–Гурҷистон, рейси мустақим, хариди чипта",

    tashkent_saudiInfo: "чиптаҳои Тошканд–Арабистони Саудӣ, рейси мустақим, хариди чипта",

    tashkent_qatarInfo: "чиптаҳои Тошканд–Қатар, рейси мустақим, хариди чипта",

    tashkent_polandInfo: "чиптаҳои Тошканд–Полша, рейси мустақим, хариди чипта",

    tashkent_latviaInfo: "чиптаҳои Тошканд–Рига, рейси мустақим, хариди чипта",

    tashkent_franceInfo: "чиптаҳои Тошканд–Фаронса, рейси мустақим, хариди чипта",

    tashkent_italyInfo: "чиптаҳои Тошканд–Рим, рейси мустақим, хариди чипта",

    tashkent_spainInfo: "чиптаҳои Тошканд–Испания, рейси мустақим, хариди чипта",

    tashkent_ukInfo: "чиптаҳои Тошканд–Британия, рейси мустақим, хариди чипта",

    tashkent_germanyInfo: "чиптаҳои Тошканд–Олмон, рейси мустақим, хариди чипта",

    tashkent_czechiaInfo: "чиптаҳои Тошканд–Чехия, рейси мустақим, хариди чипта",

    tashkent_seoulInfo: "чиптаҳои Тошканд–Сеул, рейси мустақим, хариди чипта",

    tashkent_pusanInfo: "чиптаҳои Тошканд–Пусан, рейси мустақим, хариди чипта",

    tashkent_tokyoInfo: "чиптаҳои Тошканд–Токио, рейси мустақим, хариди чипта",

    tashkent_bangkokInfo: "чиптаҳои Тошканд–Бангкок, рейси мустақим, хариди чипта",

    tashkent_phuketInfo: "чиптаҳои Тошканд–Пхукет, рейси мустақим, хариди чипта",

    tashkent_kualalumpurInfo: "чиптаҳои Тошканд–Куала-Лумпур, рейси мустақим, хариди чипта",

    tashkent_islamabadInfo: "чиптаҳои Тошканд–Исламабод, рейси мустақим, хариди чипта",

    tashkent_danangInfo: "чиптаҳои Тошканд–Дананг, рейсҳо ба Ветнам, чиптаҳои арзон",

    tashkent_delhiInfo: "чиптаҳои Тошканд–Деҳлӣ, рейси мустақим, рейсҳои Ҳиндустон",

    tashkent_denpasarInfo: "чиптаҳои Тошканд–Балӣ, рейс Тошканд–Денпасар, сайёҳии Балӣ аз Тошканд",

    tashkent_lahoreInfo: "чиптаҳои Тошканд–Лаҳор, рейси мустақим, рейсҳои Покистон",

    tashkent_mopaInfo: "чиптаҳои Тошканд–Гоа, рейс Тошканд–Мопа, истироҳат дар Гоа",

    tashkent_mumbaiInfo: "чиптаҳои Тошканд–Мумбай, рейсҳои Ҳиндустон, рейси мустақим",

    tashkent_krasnoyarskInfo: "чиптаҳои Тошканд–Красноярск, рейси мустақим, хариди чипта",

    tashkent_novgorodInfo: "чиптаҳои Тошканд–Новгород, рейси мустақим, хариди чипта",

    tashkent_kuwaitcityInfo: "чиптаҳои Тошканд–Кувайт Сити, рейси мустақим, хариди чипта",

    tashkent_tbilisiInfo: "рейси Тошканд–Тбилиси, arzon chipta Tbilisi",

    tashkent_batumiInfo: "рейси Тошканд–Батуми, arzon chipta Batumi",

    tashkent_warsawInfo: "рейси Тошканд–Варшава, arzon chipta Varshava",

    tashkent_rigaInfo: "рейси Тошканд–Рига, arzon chipta Riga",

    tashkent_sharmelsheikhInfo: "рейси Тошканд–Шарм-эш-Шайх, arzon chipta Sharm El Sheikh",

    tashkent_jeddahInfo: "рейси Тошканд–Ҷидда, arzon chipta Jeddah",

    tashkent_medinaInfo: "рейсҳои арзон Тошканд–Мадина, arzon chipta Medina",

    tashkent_oshInfo:
      "Парвозҳои арзон ва қулай Тошканд–Ош. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_issyk_kulInfo:
      "Парвозҳои арзон Тошканд–Иссиқ-Кӯл. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_ashgabatInfo:
      "Парвозҳои арзон Тошканд–Ашхабод. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_sharjahInfo:
      "Парвозҳои арзон Тошканд–Шорҷа. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_sanyaInfo:
      "Парвозҳои арзон Тошканд–Санья. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_hangzhouInfo:
      "Парвозҳои арзон Тошканд–Ҳанҷоу. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_xianInfo:
      "Парвозҳои арзон Тошканд–Сиан. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_chengduInfo:
      "Парвозҳои арзон Тошканд–Ченду. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_urumqiInfo:
      "Парвозҳои арзон Тошканд–Урумчӣ. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",

    tashkent_busanInfo:
      "Парвозҳои арзон Тошканд–Бусан. Бронкунии онлайн, рейсҳои зуд ва беҳтарин нархҳо дар Aviamarket.me.",
  },
  en: {
    homePage:
      "flights, air tickets, cheap air tickets, buy air tickets online, Uzbekistan air tickets, Tashkent air tickets, book air tickets, search for air tickets, compare ticket prices, international flights, domestic flights, tourism, travel, visa support, visa services, visa processing, Aviamarket, air tickets, cheap flights, air ticket promotions, burning tours,",
    aeroflotInfo:
      "Аэрофлот, aviabilet, aviabilet narxlari, aviabilet дешевые, aviabilet moskva, aviabilet narxlari toshkent, moskva aviabilet narxlari, купить авиабилеты, авиабилеты Аэрофлот",
    uzairwaysInfo:
      "UzAirways, Uzbekistan Airways, flights from Tashkent, Uzbekistan airline, Dreamliner, uzairways.com, international routes from Uzbekistan",
    turkishInfo:
      "turkish airlines, uzbekistan to europe, tashkent istanbul, flights turkey uzbekistan, international airline",
    belaviaInfo:
      "Belavia, Belarus airline, Tashkent–Minsk flights, Embraer E195, Boeing 737, Eastern Europe routes, CIS flights, Belavia Uzbekistan",
    uralAirlinesInfo:
      "Ural Airlines, flights Uzbekistan–Russia, Tashkent–Moscow, Samarkand–Yekaterinburg, Airbus A320, budget airline Russia, uralairlines",
    s7Info:
      "S7 Airlines, Uzbekistan to Russia flights, Tashkent–Novosibirsk, Airbus A320neo, Boeing 737, s7.ru, Oneworld airline, Russian carrier",
    qanotsharqInfo:
      "Qanot Sharq Airlines, Uzbekistan airline, Tashkent–Istanbul, budget flights Uzbekistan, Airbus A320, qanotsharq.com, Central Asia flights",
    pobedaInfo: "Pobeda Airlines, low-cost flights, Tashkent to Moscow, budget airline Russia, dushanbe24",
    airastanaInfo:
      "Air Astana, Kazakhstan airline, Tashkent–Almaty flights, Airbus A321LR, Embraer E190, Central Asia flights, flights from Uzbekistan",
    flyaristanInfo:
      "FlyArystan, low-cost airline Kazakhstan, Tashkent–Almaty, Airbus A320, budget flights Central Asia, FlyArystan Uzbekistan",
    aircairoInfo:
      "Fly from Tashkent and Samarkand to Cairo and Sharm El-Sheikh with Air Cairo. Book now via as.dushanbe24.ru.",
    airchinaInfo:
      "Air China, Chinese airline, Tashkent–Beijing flights, Star Alliance, Airbus A350, Boeing 787, Asia travel, Uzbekistan to China",
    airmanasInfo:
      "Air Manas, Kyrgyz airline, flights from Bishkek to Tashkent, Pegasus Asia, Boeing 737 Kyrgyzstan, airmanas.com, cheap regional flights",
    asianaAirlinesInfo: "Asiana Airlines, flights, Tashkent–Seoul, Incheon, Airbus, Boeing",
    aviaTrafficInfo:
      "Avia Traffic Company, Tashkent–Bishkek flights, Osh routes, charter flights to Moscow, Boeing 737, low-cost Central Asia airline",
    azalInfo:
      "AZAL, Azerbaijan Airlines, Tashkent–Baku flights, Airbus A320, Boeing Dreamliner, Azerbaijan national carrier, flights from Uzbekistan",
    azimuthInfo:
      "Azimuth Airlines, Sukhoi Superjet, flights from Tashkent, Uzbekistan–Russia routes, regional Russian flights, budget airline",
    azurairInfo:
      "Azur Air, charter airline Russia, Uzbekistan–Antalya, Hurghada flights, Boeing 767, Sharm El Sheikh, leisure travel charter airline",
    spicejetInfo:
      "aviabilet, aviabilet narxlari, aviabilet arzon, aviabilet hindiston, spicejet uzbekistan, spicejet toshkent delhi, hindiston aviabilet, arzon aviachipta, Dehli reyslari",
    iraeroInfo:
      "Iraero, airline ticket, flight ticket prices, cheap tickets, flights to Moscow, flights to Irkutsk, flights to Yakutsk",
    auroraAirlinesInfo: "Aurora Airlines, regional flights, Russian Far East, Siberia, Airbus A319, Bombardier Q400",
    yamalAirlinesInfo: "Yamal Airlines, regional flights, Salekhard, Airbus A320, Sukhoi Superjet 100",
    yakutiaAirlinesInfo:
      "Yakutia Airlines, airline tickets, fare prices, Boeing 737-700, Boeing 737-800, Sukhoi Superjet 100, Dash 8 Q300, MC-21-300, connections Moscow, connections Novosibirsk, Yakutsk Airport",
    rossiyaAirlinesInfo:
      "Rossiya Airlines, airline tickets, fare prices, cheap tickets, Tashkent flights, Moscow flights, fleet, baggage, booking",
    nordwindAirInfo:
      "Nordwind Airlines, charter flights, Uzbekistan–Antalya, Uzbekistan–Bodrum, Airbus A321, Boeing 737-800, long-haul jets, tourist airline Russia",
    lufthansaAirInfo:
      "Lufthansa, flights from Uzbekistan, Tashkent–Frankfurt, Star Alliance, Airbus A350, Boeing 747-8, international routes, European destinations",
    silkAirInfo:
      "SilkAir, Singapore Airlines, Boeing 737 MAX 8, regional flights, Southeast Asia airline, Changi connections, SilkAir history",
    tajikAirInfo:
      "Tajik Air, Dushanbe flights, Uzbekistan routes, Central Asia airlines, Boeing 737, Yak-40, cargo flights, regional air carrier",
    somonAirInfo:
      "Somon Air, Tajikistan airline, Tashkent–Dushanbe flights, Boeing 737-800, regional air carrier, Central Asia airline, charter flights",
    kamairInfo:
      "Kam Air, Kabul flights, Tashkent–Kabul, Afghanistan airline, Airbus A340, Boeing 737, Central Asia aviation, charter carrier",
    ilkarAirInfo:
      "Ilkar Air, charter flights, Tashkent–Antalya, Tashkent–Baku, Turkish airline, Boeing 737-700, Embraer E190, regional air travel",
    flydubaiAirInfo:
      "flydubai, cheap flights, Tashkent–Dubai, UAE airline, Boeing 737 MAX 8, Emirates partner, direct flights Uzbekistan",
    kuwaitAirwaysInfo:
      "Kuwait Airways – national carrier of Kuwait. Flights from Uzbekistan, modern Airbus and Boeing fleet, and international routes.",
    emiratesAirInfo:
      "Emirates, Tashkent–Dubai flights, Airbus A380, Boeing 777, UAE airline, premium service, international routes, Dubai airport",
    centrumAirInfo:
      "Centrum Air, low-cost Uzbekistan airline, Tashkent–Samarkand, Nukus flights, Airbus A320, budget tickets, regional travel",
    egyptAirInfo:
      "EgyptAir, Tashkent to Cairo, Star Alliance airline, Airbus A220, Boeing 787, North Africa airline, flights from Uzbekistan",
    chinaSouthernInfo:
      "China Southern Airlines, Tashkent–Guangzhou flights, Chinese airline, Boeing 777, Airbus A350, flights from Uzbekistan, China routes",
    piaInfo:
      "PIA, Pakistan International Airlines, Tashkent flights, Boeing 777, Airbus A320, Islamabad, Lahore, Karachi, charter flights",
    airblueInfo:
      "Airblue, Pakistan airline, Tashkent–Islamabad, private carrier, Airbus A320, affordable flights, UAE transit, digital aviation",
    sereneAirInfo:
      "SereneAir, Pakistani airline, Boeing 737, Airbus A330, Tashkent flights, Islamabad route, charter services, private carrier",
    airIndiaInfo:
      "Air India, Tashkent–Delhi flights, Boeing 787 Dreamliner, Airbus A320, Tata Group airline, India carrier, long-haul travel",
    vistaraInfo:
      "Vistara, Tata Group airline, Singapore Airlines, Airbus A320neo, Boeing 787 Dreamliner, premium Indian flights, Delhi hub",
    gulfAirInfo:
      "Gulf Air, Bahrain airline, Tashkent–Manama flights, Boeing 787 Dreamliner, Airbus A320neo, Middle East airline, Gulf carrier",
    omanAirInfo:
      "Oman Air, Oman airline, Tashkent–Muscat flights, Boeing 787 Dreamliner, Middle East aviation, Gulf carrier, premium service",
    salamAirInfo:
      "SalamAir, Tashkent–Muscat flights, Samarkand–Muscat, budget airline Oman, A320neo, A321neo, charter flights, Gulf low-cost airline",
    iranAsemanAirlinesInfo:
      "Iran Aseman Airlines, ATR 72, Fokker 100, regional Iran flights, Tehran–Tashkent connections, domestic Iranian airline",
    kishAirInfo:
      "Kish Air, Iranian airline, Kish Island flights, Tehran–Kish, MD-83, Fokker 100, domestic flights Iran, tourism travel",
    qeshmAirInfo:
      "Qeshm Air, Iran airline, Qeshm Island flights, Airbus A300, Fokker 100, RJ-85, Tehran routes, domestic aviation Iran",
    syrianAirInfo:
      "SyrianAir, Syrian airline, Damascus flights, Airbus A320, Tu-134, Yak-40, Middle East carrier, Syria national airline",
    middleEastAirlinesInfo:
      "Middle East Airlines, MEA, Beirut flights, A320neo, A330, SkyTeam, Middle East routes, Uzbekistan to Lebanon, premium service",
    aircompanyArmeniaInfo:
      "Aircompany Armenia, Armenia airline, Yerevan flights, Boeing 737-500, Armenia travel, regional air connections, flights from Uzbekistan",
    arianaAfghanAirlinesInfo:
      "Ariana Afghan Airlines, Afghan airline, Kabul flights, Boeing 737-500, Airbus A310, Central Asia routes, flights from Uzbekistan",
    georgianAirwaysInfo:
      "Georgian Airways, Tashkent–Tbilisi, Embraer 190, Boeing 737-700, Georgia airline, European connections, South Caucasus travel",
    myWayAirlinesInfo:
      "MyWay Airlines, Georgia airline, Tbilisi flights, Boeing 737, charter flights Tashkent, Samarkand, CIS connections, low-cost airline",
    koreanAirInfo:
      "Korean Air, Tashkent–Seoul flights, Korean airline, SkyTeam, Airbus A330, Boeing 777, A380, Uzbekistan–Korea, premium airline",
    jazeeraAirwaysInfo:
      "Jazeera Airways, Kuwait airline, Tashkent–Kuwait flights, A320neo, budget carrier Gulf, Middle East flights, Uzbekistan travel",
    mahanAirInfo:
      "Mahan Air, Iran airline, Tashkent–Tehran flights, Airbus A310, A340, BAe 146, long-haul routes, Mahan Uzbekistan",
    indigoAirlinesInfo:
      "IndiGo Airlines, India airline, Tashkent–Delhi flights, A320neo, ATR 72, budget travel India, Uzbekistan to India, low-cost airline",
    alrosaAirlinesInfo:
      "Alrosa Airlines, Yakutia airline, Siberian flights, Tu-154M, Boeing 737, An-24, regional Russia flights, charter services",
    turkmenistanAirlinesInfo:
      "Turkmenistan Airlines, Ashgabat flights, Tashkent–Ashgabat route, Boeing 737, Boeing 777, Central Asia airline, Turkmenistan carrier",
    saudiaAirlinesInfo:
      "Saudia Airlines, Saudi Arabian airline, Tashkent–Jeddah, Hajj flights, Umrah, Boeing 777, A330, Riyadh, Medina, SkyTeam",
    pegasusAirInfo:
      "Pegasus Airlines, low-cost carrier, Tashkent–Istanbul flights, Sabiha Gökçen, Airbus A320-200, Airbus A320neo, Airbus A321neo, Boeing 737-800, fare prices, baggage policy, budget airline Turkey",
    wizzAirInfo:
      "Wizz Air, Wizz Air flights, book Wizz Air ticket, cheap flights, Wizz Air schedule, flights from Tashkent, flights from Samarkand",
    qatarAirwaysInfo:
      "Qatar Airways, Qatar Airways flights, book Qatar Airways ticket, cheap flights, Tashkent to Doha flights, Qatar Airways schedule",
    airBalticInfo:
      "airBaltic, airBaltic flights, book airBaltic ticket, cheap flights, Tashkent to Riga flights, airBaltic schedule",
    tashkent_istanbulInfo: "Tashkent Istanbul, flights, tickets, direct flights, flight schedule, Aviamarket",
    tashkent_moscowInfo: "Tashkent Moscow, flights, direct flight, schedule, Aviamarket",
    tashkent_dubaiInfo: "Tashkent Dubai, flights, direct flight, ticket booking, schedule, Aviamarket",
    tashkent_dushanbeInfo:
      "Tashkent Dushanbe flights, cheap tickets Dushanbe, Uzbekistan Airways Dushanbe, Somon Air Dushanbe",
    tashkent_beijingInfo: "flights Tashkent Beijing, Tashkent to Beijing ticket, direct flight Tashkent Beijing",
    tashkent_bishkekInfo: "flights Tashkent Bishkek, Tashkent to Bishkek tickets, cheap flights Tashkent Bishkek",
    tashkent_belarusInfo: "flights Tashkent Minsk, Tashkent to Minsk tickets, cheap flights Tashkent Minsk",
    tashkent_almatyInfo: "flights Tashkent Almaty, Tashkent to Almaty tickets, cheap flights Tashkent Almaty",
    tashkent_azerbaijanInfo: "flights Tashkent Baku, Tashkent to Baku tickets, cheap flights Tashkent Baku",
    tashkent_georgiaInfo: "flights Tashkent Tbilisi, Tashkent to Tbilisi tickets, cheap flights Tashkent Tbilisi",
    tashkent_saudiInfo: "flights Tashkent Riyadh, Tashkent to Riyadh tickets, cheap flights Tashkent Riyadh",
    tashkent_qatarInfo: "flights Tashkent Doha, Tashkent to Doha tickets, cheap flights Tashkent Doha",
    tashkent_polandInfo: "flights Tashkent Warsaw, Tashkent to Warsaw tickets, cheap flights Tashkent Warsaw",
    tashkent_latviaInfo: "flights Tashkent Riga, Tashkent to Riga tickets, cheap flights Tashkent Riga",
    tashkent_franceInfo: "flights Tashkent Paris, Tashkent to Paris tickets, cheap flights Tashkent Paris",
    tashkent_italyInfo: "flights Tashkent Rome, Tashkent to Rome tickets, cheap flights Tashkent Rome",
    tashkent_spainInfo: "flights Tashkent Madrid, Tashkent to Madrid tickets, cheap flights Tashkent Madrid",
    tashkent_ukInfo: "flights Tashkent London, Tashkent to London tickets, cheap flights Tashkent London",
    tashkent_germanyInfo: "flights Tashkent Berlin, Tashkent to Berlin tickets, cheap flights Tashkent Berlin",
    tashkent_czechiaInfo: "flights Tashkent Prague, Tashkent to Prague tickets, cheap flights Tashkent Prague",
    tashkent_seoulInfo: "flights Tashkent Seoul, Tashkent to Seoul tickets, cheap flights Tashkent Seoul",
    tashkent_pusanInfo: "flights Tashkent Busan, Tashkent to Busan tickets, cheap flights Tashkent Busan",
    tashkent_tokyoInfo: "flights Tashkent Tokyo, Tashkent to Tokyo tickets, cheap flights Tashkent Tokyo",
    tashkent_kualalumpurInfo:
      "flights Tashkent Kuala Lumpur, Tashkent to Kuala Lumpur tickets, cheap flights Tashkent Kuala Lumpur",
    tashkent_bangkokInfo: "flights Tashkent Bangkok, Tashkent to Bangkok tickets, cheap flights Tashkent Bangkok",
    tashkent_phuketInfo: "flights Tashkent Phuket, Tashkent to Phuket tickets, cheap flights Tashkent Phuket",
    tashkent_islamabadInfo: "Tashkent Islamabad flights, direct flight Tashkent Islamabad, cheap tickets Islamabad",
    tashkent_danangInfo: "Tashkent Danang flights, Vietnam flights from Tashkent, cheap Danang tickets",
    tashkent_delhiInfo: "Tashkent Delhi flights, India direct flights, book Delhi ticket from Tashkent",
    tashkent_denpasarInfo: "Tashkent Bali flights, Denpasar tickets, tropical holiday from Tashkent",
    tashkent_lahoreInfo: "Tashkent Lahore flights, direct flight to Pakistan, cheap Lahore tickets",
    tashkent_mopaInfo: "Tashkent Goa flights, Mopa airport tickets, India beach holidays",
    tashkent_mumbaiInfo: "Tashkent Mumbai flights, direct flight India, cheap Mumbai tickets",
    tashkent_ankaraInfo: "flights Tashkent Ankara, Tashkent to Ankara tickets, cheap flights Tashkent Ankara",
    tashkent_trabzonInfo: "flights Tashkent Trabzon, Tashkent to Trabzon tickets, cheap flights Tashkent Trabzon",
    tashkent_saintpetersburgInfo:
      "flights Tashkent St Petersburg, Tashkent to St Petersburg tickets, cheap flights Tashkent St Petersburg",
    tashkent_novosibirskInfo:
      "flights Tashkent Novosibirsk, Tashkent to Novosibirsk tickets, cheap flights Tashkent Novosibirsk",
    tashkent_ekaterinburgInfo:
      "flights Tashkent Ekaterinburg, Tashkent to Ekaterinburg tickets, cheap flights Tashkent Ekaterinburg",
    tashkent_kazanInfo: "flights Tashkent Kazan, Tashkent to Kazan tickets, cheap flights Tashkent Kazan",
    tashkent_irkutskInfo: "flights Tashkent Irkutsk, Tashkent to Irkutsk tickets, cheap flights Tashkent Irkutsk",
    tashkent_groznyInfo: "flights Tashkent Grozny, Tashkent to Grozny tickets, cheap flights Tashkent Grozny",
    tashkent_samaraInfo: "flights Tashkent Samara, Tashkent to Samara tickets, cheap flights Tashkent Samara",
    tashkent_krasnoyarskInfo:
      "flights Tashkent Krasnoyarsk, Tashkent to Krasnoyarsk tickets, cheap flights Tashkent Krasnoyarsk",
    tashkent_novgorodInfo: "flights Tashkent Novgorod, Tashkent to Novgorod tickets, cheap flights Tashkent Novgorod",
    tashkent_kuwaitcityInfo:
      "flights Tashkent Kuwait City, Tashkent to Kuwait City tickets, cheap flights Tashkent Kuwait City",
    tashkent_tbilisiInfo: "Toshkent Tbilisi reyslari, arzon chipta Tbilisi",
    tashkent_batumiInfo: "Toshkent Batumi reyslari, arzon chipta Batumi",
    tashkent_warsawInfo: "Toshkent Varshava reyslari, arzon chipta Varshava",
    tashkent_rigaInfo: "Toshkent Rigidan reyslari, arzon chipta Rigidan",
    tashkent_sharmelsheikhInfo: "Toshkent Sharm el-Sheikh reyslari, arzon chipta Sharm el-Sheikh",
    tashkent_jeddahInfo: "Toshkent Jeddah reyslari, arzon chipta Jeddah",
    tashkent_medinaInfo: "flights Tashkent Medina, Tashkent to Medina tickets, cheap flights Tashkent Medina",
    tashkent_oshInfo: "flights Tashkent Osh, Tashkent to Osh tickets, cheap flights Tashkent Osh",
    tashkent_issykInfo: "flights Tashkent Issyk-Kul, Tashkent to Issyk-Kul tickets, cheap flights Tashkent Issyk-Kul",
    tashkent_ashgabatInfo: "flights Tashkent Ashgabat, Tashkent to Ashgabat tickets, cheap flights Tashkent Ashgabat",
    tashkent_sharjahInfo: "flights Tashkent Sharjah, Tashkent to Sharjah tickets, cheap flights Tashkent Sharjah",
    tashkent_sanyaInfo: "flights Tashkent Sanya, Tashkent to Sanya tickets, cheap flights Tashkent Sanya",
    tashkent_hangzhouInfo: "flights Tashkent Hangzhou, Tashkent to Hangzhou tickets, cheap flights Tashkent Hangzhou",
    tashkent_xianInfo: "flights Tashkent Xi’an, Tashkent to Xi’an tickets, cheap flights Tashkent Xi’an",
    tashkent_chengduInfo: "flights Tashkent Chengdu, Tashkent to Chengdu tickets, cheap flights Tashkent Chengdu",
    tashkent_urumqiInfo: "flights Tashkent Urumqi, Tashkent to Urumqi tickets, cheap flights Tashkent Urumqi",
    tashkent_busanInfo: "flights Tashkent Busan, Tashkent to Busan tickets, cheap flights Tashkent Busan",
    aboutPage: "AviaMarket24, about us, online flight booking, Tajikistan airline tickets, Dushanbe24",
  },
};

export default metaKeywords;
